import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { LightboxState } from '../../../components/interfaces/lightbox.interface';
@Injectable({
  providedIn: 'root'
})
export class CustomLightboxService {
  private readonly lightboxState = signal<LightboxState>({
    items: [],
    currentIndex: 0,
    isOpen: false,
    isOwner: false,
    experienceType: ''
  });

  lightboxState$ = toObservable(this.lightboxState);

  openLightbox(items: any[], index: number, isOwner: boolean, experienceType: string) {
    this.lightboxState.set({ items, currentIndex: index, isOpen: true, isOwner: isOwner, experienceType: experienceType});
  }

  closeLightbox() {
    this.lightboxState.set({ items: [], currentIndex: 0, isOpen: false , isOwner: false, experienceType: ''});
  }

  nextItem() {
    const state = this.lightboxState();
    if (state.items.length === 0) {
      return;
    }
    const newIndex = (state.currentIndex + 1) % state.items.length;
    this.lightboxState.set({ ...state, currentIndex: newIndex });
  }

  prevItem() {
    const state = this.lightboxState();
    if (state.items.length === 0) {
      return;
    }
    const newIndex = (state.currentIndex - 1 + state.items.length) % state.items.length;
    this.lightboxState.set({ ...state, currentIndex: newIndex });
  }
}
